<template>
  <review-member-assignment-setting
    label="Require Specific Reviewers for Consensus"
    description="At least one of the specified must vote on a reference"
    :review="review"
    :permission="permission"
    :disabled="disabled"
    v-on="$listeners"
  />
</template>

<script>
import ReviewMemberAssignmentSetting from './ReviewMemberAssignmentSetting';
import { Review } from '@/models';
import { ReviewMemberPermission, ReviewStage } from '@/enums';

const STAGE_TO_PERMISSION = {
  [ReviewStage.SCREENING]:
    ReviewMemberPermission.TRUSTED_SCREENING_VOTE,
  [ReviewStage.FULL_TEXT_REVIEW]:
    ReviewMemberPermission.TRUSTED_FULL_TEXT_REVIEW,
  [ReviewStage.DATA_EXTRACTION]:
    ReviewMemberPermission.TRUSTED_DATA_EXTRACTION,
};

export default {
  name: 'ConsensusTrustedReviewersSetting',
  components: {
    ReviewMemberAssignmentSetting,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    stage: {
      type: String,
      required: true,
      validator: (field) =>
        Object.values(ReviewStage).includes(field),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['assign-permission', 'unassign-permission', 'unassign-all'],
  computed: {
    permission() {
      return STAGE_TO_PERMISSION[this.stage];
    },
  },
};
</script>

<style lang="scss" scoped>
.controls {
  height: 48px;
}
</style>
